import { DayOffTemplate } from '@gooduncles/gu-app-schema';
import { Form, Input } from 'antd';
import { FC } from 'react';

interface DayOffTemplateFormProps {
  onValuesChange: (values: Partial<DayOffTemplate>) => void;
}

const DayOffTemplateForm: FC<DayOffTemplateFormProps> = ({ onValuesChange }) => {
  return (
    <Form
      layout='vertical'
      initialValues={{ category02: '' }}
      onValuesChange={(_changed, allValues) => onValuesChange(allValues)}
    >
      <Form.Item label='휴장 날짜' name='date' rules={[{ required: true, message: '필수 항목입니다.' }]}>
        <Input placeholder='예: 1월 16일(목)' maxLength={14} showCount />
      </Form.Item>
      <Form.Item label='배송 불가 상품 종류' name='products' rules={[{ required: true, message: '필수 항목입니다.' }]}>
        <Input placeholder='예: 과일/채소' maxLength={14} showCount />
      </Form.Item>
      <Form.Item label='주문 마감 기한' name='until' rules={[{ required: true, message: '필수 항목입니다.' }]}>
        <Input placeholder='예: 1월 15일(수) 오전 11시' maxLength={14} showCount />
      </Form.Item>
      <Form.Item
        label='배송 불가 카테고리 1'
        name='category01'
        rules={[{ required: true, message: '필수 항목입니다.' }]}
      >
        <Input placeholder='카테고리 목록' maxLength={14} showCount />
      </Form.Item>
      <Form.Item label='배송 불가 카테고리 2' name='category02'>
        <Input placeholder='카테고리 목록 (선택)' maxLength={14} showCount />
      </Form.Item>
      <Form.Item label='배송 지연 안내 대상' name='inform' rules={[{ required: true, message: '필수 항목입니다.' }]}>
        <Input placeholder='예: 1월 16일(목) 배송분' maxLength={14} showCount />
      </Form.Item>
      <Form.Item label='모바일 링크' name='mobile' rules={[{ required: true, message: '필수 항목입니다.' }]}>
        <Input addonBefore='https://' placeholder='URL (https:// 제외)' />
      </Form.Item>
      <Form.Item label='PC 링크' name='pc' rules={[{ required: true, message: '필수 항목입니다.' }]}>
        <Input addonBefore='https://' placeholder='URL (https:// 제외)' />
      </Form.Item>
    </Form>
  );
};

export default DayOffTemplateForm;
